export const textGeneratorApproachOptions = [
  { id: "CLEAR", value: "CLEAR", label: "Clear", title: "Clear" },
  {
    id: "PROFESSIONAL",
    value: "PROFESSIONAL",
    label: "Professional",
    title: "Professional",
  },
];
